<div [id]="getId()" class="modal fade" role="dialog">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-header">
                <button class="btn-close" data-bs-dismiss="modal" title="Schließen" type="button"></button>
            </div>

            <div class="modal-body">
                <app-offline-message></app-offline-message>
            </div>
        </div>
    </div>
</div>
